import {
  BATTERY_LOADING,
  BATTERY_ERROR,
  BATTERY_LIST,
  BATTERY_FILTERS
} from "actions/scooter/battery/constants";

const initialState = {
  loading: false,
  errors: [],

  filters: [],
  list: {
    content: []
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case BATTERY_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case BATTERY_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case BATTERY_FILTERS:
      return {
        ...state,
        errors: [],
        filters: action.payload.content,
      };
    case BATTERY_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scooter/scooter/scooterBatteryReducer.js